/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { PRODUCT_DASHBOARD_STAT_FRAGMENT } from '../fragments'

export const GET_PRODUCT_DASHBOARD_STATS = gql`
  query ProductsDashboardStats(
    $filters: ProductsDashboardFilter
    $ordering: ProductDashboardOrdering
    $pagination: OffsetLimitPaginationFilter
  ) {
    productsDashboardStats(
      filters: $filters
      ordering: $ordering
      pagination: $pagination
    ) {
      totalCount
      results {
        ...ProductDashboardStat
      }
    }
  }
  ${PRODUCT_DASHBOARD_STAT_FRAGMENT}
`

// export const GET_PRODUCT_DASHBOARD_STATS = gql`
// query ProductsDashboardStats($filters: ProductsDashboardFilter, $ordering: ProductDashboardOrdering, $pagination: OffsetLimitPaginationFilter)  {
//   productsDashboardStats(filters: $filters, ordering: $ordering, pagination: $pagination) {
//     totalCount
//     results {
//       ...ProductDashboardStat
//     }
//   }
//   ${PRODUCT_DASHBOARD_STAT_FRAGMENT}
// }
// `
